var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex", staticStyle: { height: "100%", width: "100%" } },
    [
      _c("div", { staticClass: "leftDiv flex" }, [
        _c("div", { staticClass: "schoolRank" }, [
          _c(
            "div",
            { staticClass: "tableBody" },
            _vm._l(_vm.list, function (item, indexs) {
              return _c(
                "div",
                {
                  key: indexs,
                  staticClass: "ysList",
                  style: { height: item.src != "" ? "1.34rem" : "0.4rem" },
                  on: {
                    click: function ($event) {
                      return _vm.videoClick(item, indexs)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "videoDiv flex",
                      class: item.src != "" ? "videoNav" : "wzNav",
                    },
                    [
                      item.src != ""
                        ? _c(
                            "div",
                            { staticStyle: { height: "85%", width: "90%" } },
                            [
                              _c("div", { staticClass: "topTitle" }, [
                                _vm._m(0, true),
                                _c("div", { staticClass: "circle" }, [
                                  _c("div", { staticClass: "circle_x" }, [
                                    _c(
                                      "div",
                                      { staticClass: "circle_zj num flex" },
                                      [_vm._v(" " + _vm._s(indexs + 1) + " ")]
                                    ),
                                    _c("img", {
                                      staticClass: "arround",
                                      attrs: {
                                        src: require("images/video/circle.png"),
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                              _vm._m(1, true),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "sp_wz",
                          style: {
                            color: _vm.xzIndex == indexs ? "#fff" : "#ccc",
                          },
                        },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      ),
                    ]
                  ),
                  _c("div", {
                    class: _vm.xzIndex == indexs ? "cover" : "cover1",
                  }),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "rightDiv" }, [
        _c("div", { staticClass: "contMain" }, [
          _c("div", { staticClass: "botRight" }, [
            _c(
              "div",
              { staticClass: "video-box" },
              _vm._l(_vm.rightList, function (item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "video-item",
                    class: { bling: _vm.usedIndex === i },
                  },
                  [
                    item.used
                      ? _c("video", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            id: "video" + i,
                            controls: "",
                            autoplay: "",
                          },
                        })
                      : _c("div", { staticClass: "center-text" }, [
                          _vm._v("暂无视频"),
                        ]),
                    item.used
                      ? _c("i", {
                          staticClass: "el-icon-close",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.closeVideo(i)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "xcTop flex" }, [
      _c("span", { staticStyle: { "margin-left": "13px" } }, [
        _vm._v("视频监控"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "botTitle" }, [
      _c("img", {
        staticStyle: {
          width: "calc(100% - 3px)",
          height: "calc(100% - 3px)",
          border: "1.5px solid #077EA3",
        },
        attrs: { src: require("@/assets/images/video/video-pic01.jpg") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }